var ConversationIDSerialiser = require('conversation/conversation-id-serialiser');
var CommandHeader = require('./command-header');
var Codec = require('io/codec');

/**
 * CommandHeader Serialiser
 */
var CommandHeaderSerialiser = {
    /*
     * Read a CommandHeader from an InputStream.
     *
     * @param {BufferInputStream} - The input stream
     * @returns {CommandHeader} The header that was read
     */
    read : function(input) {
        var service = Codec.readInt32(input),
            cid = ConversationIDSerialiser.read(input);

        return new CommandHeader(service, cid);
    },
    /**
     * Write a given CommandHeader to an OutputStream.
     * 
     * @param {BufferOutputStream} - The output stream
     * @param {CommandHeader} - The header to write
     */
    write : function(out, header) {

        Codec.writeInt32(out, header.service);
        ConversationIDSerialiser.write(out, header.cid);
    }
};

module.exports = CommandHeaderSerialiser;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/command-header-serialiser.js
// module id = 1033
// module chunks = 1